<div class="row">
  <div class="col">
    <table class="table" *ngIf="!namingState">
      <thead>
      <tr>
        <th>{{'lang.globals.commercial' | translate}}</th>
        <th>{{'lang.globals.duration' | translate}}</th>
        <th>{{'lang.dateRange.from' | translate}}</th>
        <th>{{'lang.dateRange.to' | translate}}</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let commercial of submissions; index as i; last as last">
        <td>
          <span [innerHTML]="(commercial?.name | truncate : 23)"></span>
        </td>
        <td>{{commercial.duration}} s</td>
        <td>{{commercial?.from?.toString() | date: 'dd.MM.yy HH:mm' }}</td>
        <td>{{commercial?.till?.toString() | date: 'dd.MM.yy HH:mm' }}</td>
        <td class="tr">
          <button (click)="deleteCommercial(i)" class="btn btn-danger">
            <sb-icon icon="trash"></sb-icon>
          </button>
        </td>
      </tr>
      </tbody>
    </table>
    <form [formGroup]="form" *ngIf="isInModalContext && editMode && namingState">
      <div class="d-flex justify-content-between align-items-center my-3">
        <div class="form-group">
          <label class="form-label" for="Name">{{'lang.globals.name' | translate}}</label>
          <input type="text" id="Name" class="form-control" formControlName="Name">
          <div *ngIf="Name.touched && Name.errors?.required"
               class="alert alert-danger">{{'lang.globals.nameWarning' | translate}}</div>
        </div>
        <div class="form-group">
          <label class="form-label" for="Description">{{'lang.globals.description' | translate}}</label>
          <input type="text" id="Description" class="form-control" formControlName="Description">
        </div>
      </div>
    </form>
    <div class="row" *ngIf="isInModalContext">
      <div
        class="col mt-3 row-body align-self-center d-flex flex-column flex-md-row justify-content-between min-width-zero align-items-md-center header">
        <button class="btn btn-secondary"
                (click)="cancel()">{{'lang.globals.cancel' | translate}}</button>
        <button class="btn btn-primary mr-2" [disabled]="editMode && namingState && form.invalid"
                (click)="ok()">{{editMode && namingState ? ('lang.globals.submit' | translate) : ('lang.globals.next' | translate)}}</button>

      </div>
    </div>
  </div>
</div>
